export default function apiUrl(): string {
  if (process.env.VUE_APP_TERMINAL_WEB_API_URI === 'USE_SERVING_HOST') {
    return window.location.origin;
  }
  return process.env.VUE_APP_TERMINAL_WEB_API_URI;
}
